// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Statistics from './Statistics';
import ReferralOptions from './ReferralOptions';
import CommissionRateInfo from './CommissionRateInfo';
import Referrals from './Referrals';
import { loadStatistics } from './Statistics/reducer';
import PageLoader from '../../components/PageLoader';

type Props = {
  loadStatistics: () => void,
  loading: boolean
};

class Dashboard extends Component<Props> {
  componentDidMount() {
    this.props.loadStatistics();
  }

  render() {
    if (this.props.loading) {
      return <PageLoader />;
    }
    return (
      <>
        <Statistics />
        <ReferralOptions />
        <CommissionRateInfo />
        <Referrals />
      </>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.dashboard.statistics.loading
});

const mapDispatchToProps = {
  loadStatistics
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);
